const QuestionTypesToId = {
    subDomain:"d42ff856-bf97-47d8-82c5-6a1ec0246922"
}

export default QuestionTypesToId;